import "bootstrap";

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from "axios";
window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";

window.io = require("socket.io-client");

// Получение порта из файла .env
const websocketPort = process.env.MIX_WEBSOCKET_PORT || 6001; // Использовать значение по умолчанию, если порт не задан в .env

window.Echo = new Echo({
    broadcaster: "socket.io",
    host: `//ws.${window.location.hostname}:${websocketPort}`,
    transports: ["websocket", "polling", "flashsocket"],
});

var socket = io.connect(`//ws.${window.location.host}:${websocketPort}`);

socket.on("connect", function () {
    console.log("Client has connected to the server!");
});

socket.on("error", (err) => {
    console.error("Socket error:", err);
});

socket.on("data", (data) => {
    try {
        const parsedData = JSON.parse(data);
        console.log("Received data:", parsedData);
    } catch (error) {
        console.error("Invalid payload:", data);
    }
});

window.onerror = function (message, source, lineno, colno, error) {
    if (
        message.includes(
            "adsbygoogle.push() error: No slot size for availableWidth=0"
        )
    ) {
        console.error("Google Ads Error: No slot size for availableWidth=0");
        // Дополнительная логика обработки ошибки
    }
    return true; // Предотвращение отображения ошибки в консоли браузера
};
